export const categoryOptions = [
  { key: 'all', label: '全部分类' },
  { key: 'traditional', label: '传统伦理剧' },
  { key: 'modern', label: '现代伦理剧' },
  { key: 'film', label: '伦理电影' },
];

export const genreOptions = ['全部题材', '家庭', '亲情', '都市', '婚姻', '悬疑', '爱情', '剧情'];

export const decadeOptions = [
  { key: 'all', label: '全部年代' },
  { key: '2010-2015', label: '2010 - 2015' },
  { key: '2016-2019', label: '2016 - 2019' },
  { key: '2020-2025', label: '2020 - 2025' },
];

export const sortOptions = [
  { key: 'newest', label: '按更新时间' },
  { key: 'hot', label: '按热度' },
  { key: 'rating', label: '按评分' },
];

interface FilterBarProps {
  cat: string;
  genre: string;
  decade: string;
  sort: string;
  onCat: (v: string) => void;
  onGenre: (v: string) => void;
  onDecade: (v: string) => void;
  onSort: (v: string) => void;
  onReset: () => void;
}

function ChipGroup({
  title,
  options,
  value,
  onChange,
}: {
  title: string;
  options: { key: string; label: string }[];
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <div>
      <h3 className="text-sm font-semibold text-foreground-950 mb-3">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt.key}
            type="button"
            onClick={() => onChange(opt.key)}
            className={`px-3 py-1.5 rounded-full text-xs transition-colors whitespace-nowrap ${
              value === opt.key
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-secondary-100'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({
  cat,
  genre,
  decade,
  sort,
  onCat,
  onGenre,
  onDecade,
  onSort,
  onReset,
}: FilterBarProps) {
  const genreOpts = genreOptions.map((g) => ({ key: g, label: g }));

  return (
    <div className="space-y-7">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-foreground-950">筛选条件</h2>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 hover:text-accent-600 transition-colors whitespace-nowrap"
        >
          重置
        </button>
      </div>
      <ChipGroup title="影视分类" options={categoryOptions} value={cat} onChange={onCat} />
      <ChipGroup title="题材类型" options={genreOpts} value={genre} onChange={onGenre} />
      <ChipGroup title="年代区间" options={decadeOptions} value={decade} onChange={onDecade} />
      <ChipGroup title="排序方式" options={sortOptions} value={sort} onChange={onSort} />
    </div>
  );
}